// extracted by mini-css-extract-plugin
export var grid = "PageRegion-module--grid--AqN-7";